import type { WorksheetSummary } from "@bindery/shared/contracts/worksheet";
import { Skeleton } from "@bindery/ui/components/ui/skeleton";
import { Link } from "react-router";
import { formatDate } from "../lib/format-date";
import { worksheetPath } from "../routes";

export function WorksheetList({
  worksheets,
  readerNickname,
}: {
  worksheets: readonly WorksheetSummary[] | null | undefined;
  readerNickname: string;
}) {
  if (worksheets === undefined) {
    return (
      <div className="flex flex-col gap-3" aria-busy="true">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    );
  }
  if (worksheets === null || worksheets.length === 0) {
    return (
      <p className="text-muted-foreground">
        No worksheets yet for {readerNickname}. Make the first one.
      </p>
    );
  }
  return (
    <ol className="divide-y border-y">
      {worksheets.map((worksheet) => (
        <li key={worksheet.worksheetId}>
          <Link
            to={worksheetPath(worksheet.worksheetId)}
            className="hover:bg-background focus-visible:bg-background flex items-baseline justify-between gap-4 py-3 outline-none"
          >
            <span className="flex flex-col">
              <span className="font-serif text-lg">
                {formatDate(worksheet.createdAt)}
              </span>
              <span className="text-muted-foreground text-sm">
                {worksheet.exerciseCount} sentences
              </span>
            </span>
            <span className="text-sm">
              {worksheet.gradedAt === null ? (
                <span className="text-muted-foreground">Not graded yet</span>
              ) : (
                <span className="text-ink-graded">
                  Graded {formatDate(worksheet.gradedAt)}
                </span>
              )}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}
